function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".I1hhl,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.TWoY9{color:var(--ricos-custom-link-color,var(--ricos-action-color,#0261ff));font-family:var(--ricos-custom-link-font-family,unset);font-size:var(--ricos-custom-link-font-size,unset);font-style:var(--ricos-custom-link-font-style,unset);font-weight:var(--ricos-custom-link-font-weight,unset);line-height:var(--ricos-custom-link-line-height,unset);min-height:var(--ricos-custom-link-min-height,unset);text-decoration:var(--ricos-custom-link-text-decoration,none)}@media only screen and (max-width:640px){.TWoY9{font-size:var(--ricos-custom-link-font-size,unset)}}[dir] .AagAZ:hover{cursor:text}[dir] .itht3:hover{cursor:pointer}.yO1xz{display:flex}[dir=ltr] .yO1xz{margin-right:5px}[dir=rtl] .yO1xz{margin-left:5px}.ye8bm{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff));max-width:270px;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.ye8bm:hover{text-decoration:underline}[dir] .jp1Db:hover{cursor:pointer}@media only screen and (max-width:640px){.ye8bm{max-width:160px}}";
var styles = {"fontElementMap":"I1hhl","link":"TWoY9","linkInEditor":"AagAZ","linkInViewer":"itht3","toolbarUrlContainer":"yO1xz","toolbarUrl":"ye8bm","toolbarUrlAnchor":"jp1Db"};
styleInject(css_248z);

export { styles as s };
//# sourceMappingURL=link-viewer-52d0a5e9.js.map
